const { Type } = require('@sinclair/typebox');

/** Builds the TypeBox schema fragment for the ReadOnlyText form element. */
function asDataDictionary(hNode) {
    const { id, title, propertyName } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // Build the string schema as optional because read-only display fields should not be required in write payloads.
    const stringOptions = {
        title: title,
        format: 'generic',
        'x-id': id,
        'x-dataType': 'string',
        'x-propertyName': propertyName,
        'x-required': false,
        'x-optional': true,
        readOnly: true
    };

    const readOnlyTextSchema = Type.Optional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
        [propertyName]: readOnlyTextSchema
    };

    return [subDataDictionary, partialTypeDefinition];
}

module.exports = { asDataDictionary };
